import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { tooltiPlacemetpProps } from "../../../data/data";
import { InfoIcon } from "../../svg";
import { black, bondiblue_color } from "../../../constant/color";

const HeaderTooltip = ({
  header = "",
  title = "",
  column,
  disabled = false,
}) => {
  const isSorted = column?.getIsSorted();
  return (
    <>
      <Tooltip title={title} {...tooltiPlacemetpProps} disableInteractive>
        {header}
        <IconButton sx={{ py: 0, px: 0.5, textAlign: "center" }}>
          <InfoIcon
            fillColor={
              disabled
                ? "rgba(0, 0, 0, 0.38)"
                : isSorted
                  ? bondiblue_color
                  : black
            }
            height="12"
            width="12"
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default HeaderTooltip;
